module.exports = __webpack_public_path__ + "img/taxcertificatehongkong.b0275a99.jpg";